import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight, Send, Save } from 'lucide-react';
import { useTaxForm } from './TaxFormContext';
import { useNavigate } from 'react-router-dom';

export const MobileNavigationButtons: React.FC = () => {
  const {
    nextStep,
    prevStep,
    isFirstStep,
    isLastStep,
    saveDraft,
    isSaving,
    handleSubmit
  } = useTaxForm();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleNext = async () => {
    await saveDraft();
    nextStep();
  };

  const handlePrev = async () => {
    await saveDraft();
    prevStep();
  };

  const handleFinalSubmit = async () => {
    setIsSubmitting(true);
    const result = await handleSubmit();
    setIsSubmitting(false);
    if (result.success) {
      navigate('/success-filing');
    }
  };

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-md z-50">
      {isSaving && (
         <div className="absolute -top-12 left-1/2 -translate-x-1/2 flex items-center gap-2 text-xs font-semibold bg-white/90 backdrop-blur-md text-primary px-4 py-1.5 rounded-full shadow-[0_8px_30px_rgb(0,0,0,0.12)] border border-white/20">
           <Save className="h-3.5 w-3.5 animate-pulse" />
           Saving...
         </div>
      )}
      
      {/* Floating Pill Dock */}
      <div className="bg-white/70 backdrop-blur-xl border border-white/50 p-2 rounded-[2rem] shadow-[0_8px_40px_-12px_rgba(0,0,0,0.2)] flex justify-between items-center gap-2">
        {!isFirstStep ? (
          <Button
            variant="ghost"
            onClick={handlePrev}
            disabled={isSaving || isSubmitting}
            className="flex-1 h-14 rounded-full flex gap-2 items-center justify-center hover:bg-slate-100/50 active:scale-95 transition-all"
          >
            <ChevronLeft className="h-5 w-5 text-slate-700" />
            <div className="flex flex-col items-start leading-none">
              <span className="text-sm font-semibold text-slate-700">Back</span>
            </div>
          </Button>
        ) : (
          <div className="flex-1" /> // Spacer
        )}

        {/* Separator if both buttons are present */}
        {!isFirstStep && <div className="w-[1px] h-8 bg-slate-200/50" />}

        {!isLastStep ? (
          <Button
            onClick={handleNext}
            disabled={isSaving || isSubmitting}
            className="flex-1 h-14 rounded-full flex gap-2 items-center justify-center active:scale-95 transition-all bg-primary hover:bg-primary/90 text-primary-foreground shadow-md shadow-primary/20"
          >
            <div className="flex flex-col items-end leading-none">
              <span className="text-sm font-bold">Next</span>
            </div>
            <ChevronRight className="h-5 w-5" />
          </Button>
        ) : (
          <Button
            onClick={handleFinalSubmit}
            disabled={isSaving || isSubmitting}
            className="flex-1 h-14 rounded-full flex gap-2 items-center justify-center active:scale-95 transition-all bg-emerald-500 hover:bg-emerald-600 text-white shadow-md shadow-emerald-500/20"
          >
            <div className="flex flex-col items-end leading-none">
              <span className="text-sm font-bold">{isSubmitting ? 'Submitting...' : 'Submit'}</span>
            </div>
            {!isSubmitting && <Send className="h-4 w-4" />}
          </Button>
        )}
      </div>
    </div>
  );
};
